import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { Cliente } from "src/app/shared/model/ajustesUsuario/cliente.model";
import swal from "sweetalert2";
import { ProyectosService } from "../proyectos.service";
import { AuthService } from "src/app/security/auth.service";
import { UtileriasService } from "src/app/utilerias/service/utilerias.service";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import { Area } from "src/app/shared/model/empleado/area.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { GenericoService } from "src/app/shared/services/generico.service";
import { comentariosAvances } from "src/app/shared/model/gestion-proyectos/comentariosAvances";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { firstValueFrom } from "rxjs";
import { rechazoDelGuardado } from "../proyecto-pagina/etapas-versiones.util";
import { mostrarRechazoDelGuardado } from "../proyecto-pagina/rechazo-del-guardado";

@Component({
  selector: "app-modal-agregar-proyecto",
  standalone: true,
  templateUrl: "./modal-agregar-proyecto.component.html",
  styleUrls: ["./modal-agregar-proyecto.component.css"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButton,
    MatIconModule,
    MatIconButton,
    MatIcon,
  ],
})
export class ModalAgregarProyectoComponent implements OnInit {
  @ViewChild("inputNameProject") inputNameProjectCtrl: ElementRef;
  clientes: Cliente[];
  listArea: Area[];
  proyecto: Proyecto;
  formGroupProject: FormGroup;
  paletaColores = [];
  tituloModal: string;
  fechaInicio: string;
  fechaFin: string;
  comentario: comentariosAvances;
  dateNow: Date = new Date();
  fechaActual: string;
  id_usuario: number;
  nombreUsuario: string;

  constructor(
    public dialogRef: MatDialogRef<ModalAgregarProyectoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Proyecto,
    private formBuilder: FormBuilder,
    private proyectosService: ProyectosService,
    private authService: AuthService,
    private utilerias: UtileriasService,
    private empleadoService: EmpleadoService,
    private generico: GenericoService,
    private authS: AuthService
  ) {}

  ngOnInit() {
    this.authS.getSesion().subscribe((res) => {
      this.id_usuario = res.usuario.id;
      this.nombreUsuario = res.persona.nombreCompleto;
    });

    this.proyecto = new Proyecto();
    this.comentario = new comentariosAvances();
    this.tituloModal = "Agregar Proyecto";

    if (this.utilerias.validarObjecto(this.data)) {
      this.proyecto = this.data;
      this.tituloModal = "Actualizar avances";
    }

    this.formGroupProject = this.formBuilder.group({
      nameProjectCtrl: ["", Validators.required],
      nameProjectShortCtrl: ["", Validators.required],
      areaProjectCtrl: ["", Validators.required],
      customerCtrl: ["", Validators.required],
      colorCtrl: [{ value: "", disabled: true }],
      descriptionProjectCtrl: [""],
      avanceReal: ["", [Validators.pattern("^([1-9]|[1-9][0-9]|100)$")]],
      comentarios: ["", Validators.required],
    });

    this.proyectosService
      .findAllCustomers(new Cliente())
      .subscribe((response) => {
        if (response) {
          this.clientes = response;
        }
      });

    this.consultaAreas();
    this.consultaPaletaColores();
    this.obtenerDiasHabiles(this.proyecto.fechaInicio, this.proyecto.fechaFin);
  }

  consultaAreas(): void {
    this.empleadoService.consultaAreas().subscribe((res) => {
      this.listArea = res.list;
    });
  }

  consultaPaletaColores(): void {
    firstValueFrom(
      this.generico.obtenerColeccion(UrlConstantes.OBTENER_PALETA_COLORES)
    )
      .then((res) => {
        this.paletaColores = res;
      });
  }

  clear(): void {
    if (this.tituloModal === "Agregar Proyecto") {
      this.formGroupProject.reset();
      this.inputNameProjectCtrl.nativeElement.focus();
    } else {
      this.formGroupProject.get("avanceReal").setValue(null);
      this.formGroupProject.get("comentarios").setValue(null);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  formatFecha(str: any): string {
    const date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  isValidDates(): boolean {
    const startDate = this.formGroupProject.controls.dateStartCtrl
      ?.value as Date;
    const endDate = this.formGroupProject.controls.dateEndCtrl?.value as Date;

    if (!endDate) {
      this.proyecto.fechaInicio = startDate;
      this.proyecto.fechaFin = null;
      return true;
    }

    return this.isValidRangeofDates(startDate, endDate);
  }

  isValidRangeofDates(startDate: Date, endDate: Date): boolean {
    if (startDate.getTime() > endDate.getTime()) {
      return false;
    }

    this.proyecto.fechaInicio = startDate;
    this.proyecto.fechaFin = endDate;
    return true;
  }

  obtenerDiasHabiles(rangoInicio: Date, rangoFin: Date): void {
    const fechaInicio: Date = new Date(rangoInicio);
    const fechaFin: Date = new Date(rangoFin);

    let diasHabiles = 0;

    while (fechaInicio <= fechaFin) {
      const diaSemana = fechaInicio.getDay();
      if (diaSemana !== 0 && diaSemana !== 6) {
        diasHabiles++;
      }
      fechaInicio.setDate(fechaInicio.getDate() + 1);
    }

    this.proyecto.porcentajeAvance = diasHabiles;
  }

  save(): void {
    const comentarioNuevo = this.formGroupProject
      .get("comentarios")
      .value?.trim();
    if (!comentarioNuevo) {
      swal.fire("Atención", "Debes escribir un comentario", "warning");
      return;
    }

    this.fechaActual = this.formatFecha(this.dateNow.toString());

    let ultimoId = 0;
    if (this.proyecto?.comentariosAvances?.length > 0) {
      ultimoId = Math.max(...this.proyecto.comentariosAvances.map((c) => c.id));
    }
    const nuevoId = ultimoId + 1;

    const nuevoComentario = {
      id: nuevoId,
      descripcion: comentarioNuevo,
      fecha: this.fechaActual,
      id_usuario: this.id_usuario,
      id_proyecto: this.proyecto.idProyecto,
      nombreUsuario: this.nombreUsuario,
      porcentajeRegistrado: this.formGroupProject.get("avanceReal").value,
    };

    if (this.proyecto.comentariosAvances) {
      this.proyecto.comentariosAvances.push(nuevoComentario);
    } else {
      this.proyecto.comentariosAvances = [nuevoComentario];
    }

    this.proyectosService.saveProyect(this.proyecto).subscribe((response) => {
      // Rechazos del guardado (etapas y versiones, §5.8): no se guardó nada; el
      // comentario sale de la copia en memoria y el diálogo sigue abierto.
      const rechazo = rechazoDelGuardado(response);
      if (rechazo) {
        this.proyecto.comentariosAvances = this.proyecto.comentariosAvances.filter((c) => c !== nuevoComentario);
        mostrarRechazoDelGuardado(rechazo);
        return;
      }
      swal
        .fire({
          title: "ÉXITO",
          text: response.pMensaje,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          confirmButtonText: "Aceptar",
          icon: "success",
        })
        .then(() => {
          // ✅ Solo se cierra el modal cuando el usuario presiona "Aceptar"
          this.dialogRef.close(true);
        });
      // Limpieza del campo comentario
      this.formGroupProject.get("comentarios").reset();
    });
  }
}
